function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ic_copy-a",
  d: "M19 6a2 2 0 0 1 1.995 1.85L21 8v12a2 2 0 0 1-1.85 1.995L19 22H9a2 2 0 0 1-1.995-1.85L7 20V8a2 2 0 0 1 1.85-1.995L9 6h10zm0 2H9v12h10V8zm-2-6v2H5v14H3V4a2 2 0 0 1 1.85-1.995L5 2h12z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ic_copy-a"
});

var SvgIcCopy2 = function SvgIcCopy2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCopy2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_copy_2.f8f4bc12.svg";
export { ForwardRef as ReactComponent };